"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const button_1 = __importDefault(require("components/cosmos/button/button"));
const tag_1 = require("components/cosmos/tag");
const translationContext_1 = require("configs/translationContext");
const mobx_react_1 = require("mobx-react");
const player_1 = require("modules/app/services/datahub/player");
const configManager_1 = require("modules/configManager");
const PlayerModal_1 = __importDefault(require("modules/player/components/PlayerModal"));
const ui_1 = require("modules/ui");
const HotmartPlayerInactiveBadge = ({ UserStore }) => {
    const [isModalOpen, setIsModalOpen] = (0, react_1.useState)(false);
    const { t } = (0, translationContext_1.useTranslation)();
    const [addOnCost, setAddOnCost] = (0, react_1.useState)();
    const [bundleAddOnCost, setBundleAddOnCost] = (0, react_1.useState)();
    const fetchStreamingCosts = async () => {
        const { addOnCost } = (await configManager_1.ConfigService.getStreamingCosts()) || {};
        setAddOnCost(addOnCost);
    };
    const fetchBundleStreamingCosts = async () => {
        const bundleAddOnCost = await configManager_1.ConfigService.getBundleStreamingCosts();
        setBundleAddOnCost(bundleAddOnCost);
    };
    (0, react_1.useEffect)(() => {
        if (isModalOpen) {
            fetchStreamingCosts();
            fetchBundleStreamingCosts();
        }
    }, [isModalOpen]);
    const handleModalConfirm = async () => {
        setIsModalOpen(false);
        await configManager_1.ConfigService.updateStreamingStatus({ active: true });
        ui_1.UiService.setAlertSuccess('done');
        player_1.DataHubPlayerService.confirmPlayerActivationOnContentPageEvent({
            marketplaceId: parseInt(UserStore === null || UserStore === void 0 ? void 0 : UserStore.marketplaceId)
        });
    };
    const handleModalCancel = () => {
        setIsModalOpen(false);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "_d-flex _align-items-center _ml-2", children: (0, jsx_runtime_1.jsx)(button_1.default, { size: "sm", type: "button", variation: "custom", className: "_text-1", onClick: () => setIsModalOpen(true), children: (0, jsx_runtime_1.jsx)(tag_1.Tag, { children: t('player_inactive_info_modal.title') }) }) }), isModalOpen && ((0, jsx_runtime_1.jsx)(PlayerModal_1.default, { addOnCost: addOnCost, bundleAddOnCost: bundleAddOnCost, onConfirm: handleModalConfirm, onClose: handleModalCancel }))] }));
};
exports.default = (0, mobx_react_1.inject)((stores) => ({
    userId: stores.UserStore.marketplaceId
}))(HotmartPlayerInactiveBadge);
